import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const IconWrapper = styled.div<{
  color: string;
  isProfileMenu?: boolean;
  isOtherAccount?: boolean;
}>`
  border-radius: 20px;
  width: ${props => (props.isProfileMenu ? '32px' : '40px')};
  height: ${props => (props.isProfileMenu ? '32px' : '40px')};
  margin-right: 12px;
  color: ${props => (props.isOtherAccount ? globals.MOON_600 : globals.WHITE)};

  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.color};
`;
